import React from "react";
import EvaluarCriterioFormBase from "../../../../components/Shared/EvaluarCriterioFormBase";

export default function EvaluaarProyectoFormNotaModelForm(props: any) {
  return <EvaluarCriterioFormBase {...props} titulo="Evaluar criterio" />;
}
